import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex: 0 0 36.8%;
    padding: ${rem('66px')} ${rem('40px')} 0 ${rem('24px')};
    background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-basis: 37%;
  }
`;
